module.exports = __webpack_public_path__ + "img/u85.e10149ef.svg";